import { createAction, props } from '@ngrx/store';
import { Manual } from 'src/app/core/models/Manual';
import { IBookingCredentialsData } from 'src/app/core/models/booking-credentials.model';
import {
  BreadcrumbRoute,
  ContractError,
  ChangePasswordRequest,
  IAlertMessage
} from 'src/app/core/models/models';

export const LoadLayouts = createAction('[Layout] Load Layouts');

export const ValidateDashboardReturn = createAction('[Layout Dashboard] Return Dashboard Filter');

export const ChangeBreadcrumb = createAction(
  '[Layout Dashboard Breadcrumb] Change BreadcrumbRoute',
  props<{ breadcrumb: BreadcrumbRoute[] }>()
);

export const SaveNewAlertMessage = createAction(
  '[Layout Alert Messages] Save New Alert Message',
  props<{ alertMessage: IAlertMessage }>()
);

export const RemoveAlertMessage = createAction(
  '[Layout Alert Messages] Remove An Alert Message',
  props<{ alertMessage: IAlertMessage }>()
);

export const GenericError = createAction(
  '[APP] Generic Error',
  props<{ error: ContractError; titleKey?: string }>()
);

export const CloseError = createAction('[APP] Close Generic Error');

export const OpenChangePassword = createAction(
  '[APP Layout] Open Change Password',
  props<{ openChangePassword: boolean }>()
);

export const ChangePassword = createAction(
  '[APP Layout] Change Password',
  props<{ request: ChangePasswordRequest }>()
);

export const ChangePasswordSuccess = createAction('[APP Layout] Change Password Success');

export const LoadManualInfo = createAction(
  '[APP Layout] Load Manual Info',
  props<{ language: string }>()
);

export const LoadManualInfoSuccess = createAction(
  '[APP Layout] Load Manual Info Success',
  props<{ manualInfo: Manual }>()
);

export const DownloadManual = createAction('[APP Layout] Download Manual', props<{ id: string }>());

export const DownloadManualSuccess = createAction(
  '[APP Layout] Download Manual Success',
  props<{ manual: string }>()
);

export const SaveLanguage = createAction(
  '[APP Layout] Save language',
  props<{ language: string }>()
);

export const RequireBookingCredentials = createAction('[APP Layout] Require booking credentials');

export const UpdateBookingCredentials = createAction(
  '[APP Layout] Update booking credentials',
  props<{ credentials: IBookingCredentialsData }>()
);

export const SetReceivedFrom = createAction(
  '[APP Layout] Set Received From',
  props<{ receivedFrom: string }>()
);

export const RemoveReceivedFrom = createAction('[APP Layout] Remove Received From');

export const SabreAirlineEPRLogin = createAction(
  '[APP Layout] Log in Sabre Airline EPR',
  props<{ sabreAirlineCredentialsData: IBookingCredentialsData }>()
);

export const SabreAirlineEPRLoginSuccess = createAction(
  '[APP Layout] Log in Sabre Airline EPR Success',
  props<{ info: string }>()
);

export const SabreAirlineEPRLoginError = createAction(
  '[APP Layout] Log in Sabre Airline EPR Error',
  props<{ message: string }>()
);
